import NextLink, { LinkProps as NextLinkProps } from 'next/link';
interface LinkProps extends NextLinkProps {
  className?: string;
}
export default function Link({
  href,
  children,
  ...props
}: React.PropsWithChildren<LinkProps>) {
  return <NextLink href={href} {...props} data-sentry-element="NextLink" data-sentry-component="Link" data-sentry-source-file="link.tsx">
            {children}
        </NextLink>;
}